import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasTemplatesList = lazy(() =>
  import("@scenes/CanvasTemplates/CanvasTemplatesList").then((module) => ({
    default: module.CanvasTemplatesList,
  }))
);

export const canvasTemplatesNRO: NavigationRoutingObject = {
  Component: CanvasTemplatesList,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-templates", "Canvas Templates"),
  pageNameForTracking: () => "Canvas Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("canvas-templates-description", "Create and manage Canvas templates"),
  icon: "nav-system-canvas",
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      // "canvases" (plural) does not match the heading "Canvas Templates"
      keywords: [t("canvas-templates-alt-keyword-1", "Canvases templates")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/canvas_templates/:appGroupId",
};
